import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { createSupplier } from '../../services/firestoreService';
import SupplierForm from './SupplierForm';

export default function SupplierNew() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    if (!data.companyName) {
      setErrorMessage('Company Name is required.');
      return;
    }

    setErrorMessage('');
    setIsSubmitting(true);

    try {
      const supplier = await createSupplier(data);
      navigate(`/supplier/${supplier.id}`);
    } catch (error) {
      console.error(error);
      setErrorMessage('Error saving supplier.');
      setIsSubmitting(false);
    }
  };

  return (
    <SupplierForm
      onSubmit={handleSubmit}
      submitLabel={isSubmitting ? 'Saving...' : 'Save Supplier'}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
      title="Add Supplier"
    />
  );
}
